module.exports = __webpack_public_path__ + "static/media/143.fbd47985.webp";